import VSelectCardUpdateState from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCardUpdateState', VSelectCardUpdateState),
};
